import React, { useContext, useEffect, useState } from 'react';

// context api
import AuthContext from '../../authContext';

// material component
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  IconButton,
  DialogActions,
  Divider,
} from '@material-ui/core';
import theme from '../../theme';
import Pagination from '@material-ui/lab/Pagination';

// icons
import Icon from '@mdi/react';
import { mdiCheck, mdiClose, mdiHelp, mdiPencilOutline, mdiPlus } from '@mdi/js';

// components
import Can from '../../components/Can';
import List from './components/list';
import Add from './components/add';
import Modal from '../../components/Modal';

// interfaces & types
import { Props, addZone, editZone } from './interfaces';

import { removeEmptyValueObject } from '../../utils/helpers';
import Edit from './components/edit';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import warehouseZoneRepository from 'client-sdk/src/Repository/warehouse-zones-repository';
import useQuery from '../../utils/hook/useQuery';

// styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    deActiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#ddd',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      minWidth: '195px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
  })
);

const WarehouseZones: React.FC<Props> = (props: Props): React.ReactElement => {
  const authContext = useContext(AuthContext);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [openSize, setOpenSize] = useState(false as boolean);
  const [openAddModal, setOpenAddModal] = useState(false as boolean);
  const [zoneData, setZoneData] = useState(null as null | addZone);
  const [editZoneData, setEditZoneData] = useState(null as null | editZone);
  const [checkAddZone, setCheckZone] = useState(false as boolean);
  const [checkEditZone, setCheckEditZone] = useState(false as boolean);
  const [openEditModal, setOpenEditModal] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);

  const [warehouseZones, setWarehouseZones] = useState([]);
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const classes = useStyles();

  useEffect(() => {
    getWarehouseZones();
  }, [filtersValues]);
  const getWarehouseZone = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const { response, count } = await warehouseZoneRepository.getWarehouseZones(
        { payload }
      );
      setWarehouseZones(response.data);
      setCount(count.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getWarehouseZones = () => {
    const { page, size } = filtersValues;

    getWarehouseZone({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const handleClose = () => {
    setOpenSize(false);
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleCreateZone = (body: addZone) => {
    setZoneData(body);
    setCheckZone(true);
  };

  const handleCloseEditCheck = () => {
    setCheckEditZone(false);
    setEditZoneData(null);
  };

  const updateZoneStatus = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const pagination = await warehouseZoneRepository.updateZoneStatus({
        payload,
      });
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleDisableZone = () => {
    updateZoneStatus({
      id,
      body: 'UNAVAILABLE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });
    setOpenConfirmDisable(false);
  };

  const handleActiveZone = () => {
    updateZoneStatus({
      id,
      body: 'AVAILABLE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });
    setOpenConfirmActive(false);
  };

  const handleCloseCheck = () => {
    setCheckZone(false);
    setZoneData(null);
  };

  const handleSubmitNewZone = () => {
    const callback = () => {
      setCheckZone(false);
      setOpenAddModal(false);
      setZoneData(null);
      getWarehouseZones();
    };

    const {
      aisleCount,
      columnCount,
      unitCount,
      rowCount,
      warehouseId,
      isWastage,
    }: addZone = zoneData!;
    const createZone = async (actions: any) => {
      const payload = { ...actions };
      try {
        setLoading(true);
        const { pagination, callback } = await warehouseZoneRepository.createZone(
          { payload }
        );
        callback();
        handleNotfication('زون جدید با موفقیت اضافه شد', 'success');
      } catch (error) {
        setError(error.message);
        handleNotfication('مشکلی پیش آمده لطفا دوباره تلاش کنید', 'error');
      } finally {
        setLoading(false);
      }
    };
    createZone({
      body: {
        aisleCount: +aisleCount,
        columnCount: +columnCount,
        unitCount: +unitCount,
        rowCount: +rowCount,
        warehouseId: +warehouseId,
        isWastage: +isWastage,
      },
      pagination: filtersValues,
      callback,
    });
  };
  const editZone = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const { pagination, callback } = await warehouseZoneRepository.editZone({
        payload,
      });
      callback();
      handleNotfication('زون انتخابی با موفقیت ویرایش شد', 'success');
    } catch (error) {
      setError(error.message);
      handleNotfication('ویرایش زون با خطا مواجه شد', 'error');
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitEditZone = () => {
    const callback = () => {
      setCheckEditZone(false);
      setOpenEditModal(false);
      setZoneData(null);
    };
    const { id, unitCount, isWastage }: editZone = editZoneData!;
    editZone({
      body: {
        id: +id,
        unitCount: +unitCount,
        isWastage: +isWastage,
      },
      pagination: filtersValues,
      callback,
    });
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);

    setId(id);
  };
  const handleOpenConfirmActive = (id: number) => {
    setOpenConfirmActive(true);
    setId(id);
  };

  const handleOpenEditModal = (id: number) => {
    setId(id);
    setOpenEditModal(true);
  };

  const updateZone = (data: editZone) => {
    setEditZoneData(data);
    setCheckEditZone(true);
  };

  const handleCloseEditModal = () => setOpenEditModal(false);
  return (
    <div className={classes.root}>
      <Grid container justify="space-between" item xs={12} alignItems="center">
        <Grid item>
          <Typography variant="h6" component="h2">
            لیست زون‌های انبار
          </Typography>
        </Grid>
        <Grid item>
          <Can
            role={authContext.user.role}
            perform="warehouse-zones:add"
            yes={() => (
              <>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<Icon path={mdiPlus} size={1} />}
                  onClick={() => {
                    setOpenAddModal(true);
                  }}
                >
                  تعریف زون جدید
                </Button>
              </>
            )}
          />
        </Grid>
      </Grid>
      <Box mb={4} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {warehouseZones.length > 0 ? (
                <List
                  data={warehouseZones}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  handleOpenConfirmActive={handleOpenConfirmActive}
                  handleOpenEditModal={handleOpenEditModal}
                />
              ) : (
                <Box mt={4}>
                  <Typography variant="h3" component="div">
                    محموله موجود نیست
                  </Typography>
                </Box>
              )}
            </>
          )}
          <Box mt={3} />
          {warehouseZones.length > 0 && (
            <Grid container>
              <Grid item xs={12} sm={6}>
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} container item direction="row-reverse">
                <Pagination
                  className={classes.pagination}
                  count={Math.ceil(count / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Modal
        onClose={() => setOpenAddModal(false)}
        open={openAddModal}
        title={
          <div className={classes.addIcon}>
            <Icon path={mdiPlus} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Add
            onClose={() => setOpenAddModal(false)}
            count={count}
            error={error}
            createZone={handleCreateZone}
          />
        }
      />

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        title={
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
        }
        content={
          <Edit
            data={warehouseZones.find(zone => zone.id === id)}
            updateZone={updateZone}
            error={error}
            onClose={handleCloseEditModal}
          />
        }
      />

      <Dialog
        fullWidth
        open={checkAddZone}
        onClose={handleCloseCheck}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseCheck ? (
              <IconButton aria-label="close" onClick={handleCloseCheck}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiHelp} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`آیا از ایجاد کردن زون ${zoneData?.name} اطیمنان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseCheck}
                variant="outlined"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleSubmitNewZone}
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="primary" />
                ) : (
                  'ایجاد زون'
                )}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={checkEditZone}
        onClose={handleCloseEditCheck}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseEditCheck ? (
              <IconButton aria-label="close" onClick={handleCloseEditCheck}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiHelp} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`آیا از ویرایش کردن زون ${warehouseZones.find(zone => zone.id === editZoneData?.id)?.name
              } اطیمنان دارید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseEditCheck}
                variant="outlined"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleSubmitEditZone}
                fullWidth
                variant="contained"
                size="large"
                color="primary"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="primary" />
                ) : (
                  'ویرایش زون'
                )}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از

          ${openConfirmDisable ? 'غیر' : ''}

          فعال کردن زون با نام
          "${warehouseZones.find(zone => zone.id === id)?.name}"
          اطمینان دارید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="outlined"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableZone}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={loading}
                >
                  {'غیرفعال کردن'}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveZone}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  {loading ? (
                    <CircularProgress size={24} color="primary" />
                  ) : (
                    'فعال کردن'
                  )}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};


export default WarehouseZones;
